import * as React from 'react'

import Badge from 'airship/patterns/badge'

const NewItem: React.FC = ({children}) => {
  return (
    <>
      {children}
      <Badge
        style="pill"
        displayClasses="u-space-left-03"
        foreground="white"
        background="blue"
      >
        NEW
      </Badge>
    </>
  )
}

export default NewItem
